// Pattern to stop silly negative numbers like "-0" or "-0.0" appearing.
export const NEGATIVE_ZERO_PATTERN = /-0\.?(0+)?$/;
